const numberMask = value => {
  if (!value) {
    return value
  }

  return value.replace(/[^\d]/g, '')
}

export default numberMask



// WEBPACK FOOTER //
// ./src/alelo-logic/utils/numberMask.js